<template>
  <div class="contenedor-menu">
    <AppMenu/>
    <div class="main-content">
      <BarraSuperior/>
      <div class="medio">
        <main class="contenedor">
          <template v-if="route.path === '/Gestion'">
            <img src="@/assets/udi-logo.png" alt="imagen centrada" class="imagen-centrada" />
          </template>
          <router-view v-else />
        </main>    
      </div>       
    </div>   
  </div>
</template>

<script lang="ts" setup>
/**
 * Layout raíz de la aplicación: menú lateral, barra superior y `router-view`.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/Gestion` (Inicio) — sin permiso específico
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

import AppMenu from '../components/AppMenu.vue';
import BarraSuperior from '../components/BarraSuperior.vue';
import { useRoute } from 'vue-router'

const route = useRoute()
</script>

<style scoped>
.contenedor-menu {
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  width: 100%;
  overflow-x: auto;
  box-sizing: border-box;
}

.contenedor-menu > :first-child {
  flex: 0 0 240px; 
  min-width: 200px;
}

.main-content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow-x: auto;
  overflow-y: hidden; 
}

.medio {
  display: flex;
  flex: 1 1 auto;
  gap: var(--space-base);
  padding: var(--space-base);
  align-items: stretch;
  flex-wrap: wrap;
  overflow-x: auto;
  overflow-y: hidden;
  box-sizing: border-box;
}

.contenedor {
  flex: 1 1 600px;
  display: flex;
  flex-direction: column;
  padding: var(--space-lg);
  background-color: rgb(220, 223, 224);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  margin: 10px;
  min-height: 0;
  min-width: 0;
  max-width: 100%;
}

.imagen-centrada {
  max-width: 300px;
  max-height: 200px;
  width: 100%;
  height: auto;
  margin: auto;
  display: block;
}


.contenedor-menu::-webkit-scrollbar,
.medio::-webkit-scrollbar,
.main-content::-webkit-scrollbar {
  height: 10px;
}

.contenedor-menu::-webkit-scrollbar-thumb,
.medio::-webkit-scrollbar-thumb,
.main-content::-webkit-scrollbar-thumb {
  background-color: #0e69a0;
  border-radius: 5px;
}

.contenedor-menu::-webkit-scrollbar-track,
.medio::-webkit-scrollbar-track,
.main-content::-webkit-scrollbar-track {
  background-color: #ddd;
}

@media (max-width: 768px) {
  .contenedor-menu {
    flex-direction: column;
    min-height: auto;
  }

  .medio {
    flex-direction: column; 
    padding: 10px;
    min-width: auto;
    overflow-x: hidden; 
  }

.contenedor {
    flex: 1;
    width: 100%;
    margin: 5px 0;
    border-radius: 8px;
    min-width: auto;
  }

  .imagen-centrada {
    max-width: 200px;
    max-height: 120px;
    margin: 2rem auto;
  }
}
</style>